import { Splide } from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', () =>
{
	document.querySelectorAll<HTMLElement>(".feature-section-image-slider").forEach(el =>
	{

		let splideElement = el.querySelector<HTMLElement>(".splide");

		if (splideElement)
		{
			var splide = new Splide(splideElement, {
				pagination: true,
				gap: 20,
				mediaQuery: "min",
				fixedWidth: 280,
				arrows: false,
				flickPower: 10,
				breakpoints: {
					768: {
						pagination: false,
						arrows: true,
						gap: 40,
						direction: el.classList.contains("right") ? "rtl" : "ltr",
					},
					992: {
						fixedWidth: 460,
					}
				}
			});

			splide.mount();


			var scrollbar = el.querySelector<HTMLElement>(".feature-section-image-slider .custom-scrollbar");
			var thumb = el.querySelector<HTMLElement>(".feature-section-image-slider .scrollbar-thumb");

			if (scrollbar != null && thumb != null)
			{
				new SyncScrollbar(splide, scrollbar, thumb, el.classList.contains("right"));
			}
		}
	});

	document.querySelectorAll<HTMLElement>(".featured-slider .splide").forEach(el =>
	{
		new Splide(el, {
			pagination: true,
			gap: 100,
			mediaQuery: "min",
			arrows: true,
			flickPower: 100,
			perPage: 1
		}).mount();
	});

	document.querySelectorAll<HTMLElement>(".events-slider .splide").forEach(el =>
	{
		var splide = new Splide(el, {
			pagination: true,
			gap: 20,
			mediaQuery: "min",
			fixedWidth: 270,
			arrows: false,
			flickPower: 10,
			breakpoints: {
				768: {
					pagination: false,
					arrows: true,
					gap: 32,
					fixedWidth: 326,
					slideFocus: "false"
				}
			}
		}).mount();

		var elSlider = el.closest(".events-slider");

		if (elSlider)
		{
			var scrollbar = elSlider.querySelector<HTMLElement>(".events-slider .custom-scrollbar");
			var thumb = elSlider.querySelector<HTMLElement>(".events-slider .scrollbar-thumb");

			if (scrollbar != null && thumb != null)
			{
				new SyncScrollbar(splide, scrollbar, thumb, false);
			}
		}
	});



	document.querySelectorAll<HTMLElement>(".generic-slider .splide").forEach(el =>
	{
		var splide = new Splide(el, {
			pagination: true,
			gap: 20,
			mediaQuery: "min",
			fixedWidth: 330,
			arrows: false,
			flickPower: 10,
			breakpoints: {
				768: {
					pagination: false,
					arrows: true,
					gap: 32,
					fixedWidth: 388,
					slideFocus: "false"
				}
			}
		}).mount();

		var elSlider = el.closest(".generic-slider");

		if (elSlider)
		{
			var scrollbar = elSlider.querySelector<HTMLElement>(".generic-slider .custom-scrollbar");
			var thumb = elSlider.querySelector<HTMLElement>(".generic-slider .scrollbar-thumb");

			if (scrollbar != null && thumb != null)
			{
				new SyncScrollbar(splide, scrollbar, thumb, false);
			}
		}
	});


	document.querySelectorAll<HTMLElement>(".news-block .splide").forEach(el =>
	{
		new Splide(el, {
			pagination: true,
			gap: 20,
			mediaQuery: "min",
			fixedWidth: 270,
			arrows: false,
			flickPower: 10,
			breakpoints: {
				992: {
					destroy: true
				}
			}
		}).mount();
	});

	document.querySelectorAll<HTMLElement>(".instagram-scroller .splide").forEach(el =>
	{
		var splide = new Splide(el, {
			pagination: true,
			gap: 32,
			mediaQuery: "min",
			fixedWidth: 226,
			arrows: false,
			flickPower: 10,
			breakpoints: {
				768: {
					pagination: false,
					arrows: true,
					slideFocus: "false"
				}
			}
		}).mount();


		var scrollbar = document.querySelector<HTMLElement>(".instagram-scroller .custom-scrollbar");
		var thumb = document.querySelector<HTMLElement>(".instagram-scroller .scrollbar-thumb");

		if (scrollbar != null && thumb != null)
		{
			new SyncScrollbar(splide, scrollbar, thumb, false);
		}
	});

	document.querySelectorAll<HTMLElement>(".leaderboard-slider .splide").forEach(el =>
	{
		new Splide(el, {
			pagination: true,
			gap: 20,
			mediaQuery: "min",
			fixedWidth: 270,
			arrows: false,
			flickPower: 10,
			focus: "center",
			trimSpace: true,
			breakpoints: {
				768: {
					destroy: true
				}
			}
		}).mount();
	});

	document.querySelectorAll<HTMLElement>(".team-member-row-block__splide").forEach(el =>
	{
		let splideElement = el.querySelector<HTMLElement>(".splide");

		if (splideElement)
		{
			var splide = new Splide(splideElement, {
				pagination: true,
				gap: 20,
				mediaQuery: "min",
				fixedWidth: 292,
				arrows: false,
				flickPower: 10,
				breakpoints: {
					768: {
						destroy: true
					}
				}
			}).mount();
		}
	});



	document.querySelectorAll<HTMLElement>(".gallery-banner-block__splide").forEach(el =>
	{
		let splideElement = el.querySelector<HTMLElement>(".splide");

		if (splideElement)
		{
			var splide = new Splide(splideElement, {
				pagination: true,
				gap: 20,
				mediaQuery: "min",
				//fixedWidth: 292,
				arrows: true,
				flickPower: 10
			}).mount();
		}
	});


	document.querySelectorAll<HTMLElement>(".small-content-slider").forEach(el =>
	{
		let disableDesktopScroll = el.classList.contains("no-scroll");

		let splideElement = el.querySelector<HTMLElement>(".splide");

		if (splideElement)
		{
			var splide = new Splide(splideElement, {
				pagination: true,
				gap: 20,
				mediaQuery: "min",
				fixedWidth: 252,
				arrows: false,
				flickPower: 10,
				breakpoints: {
					768: {
						pagination: false,
						arrows: true,
						destroy: disableDesktopScroll,
						slideFocus: "false"
					}
				}
			}).mount();


			var scrollbar = el.querySelector<HTMLElement>(".small-content-slider .custom-scrollbar");
			var thumb = el.querySelector<HTMLElement>(".small-content-slider .scrollbar-thumb");

			if (scrollbar != null && thumb != null)
			{
				new SyncScrollbar(splide, scrollbar, thumb, false);
			}
		}
	});


	document.querySelectorAll<HTMLElement>(".large-content-slider").forEach(el =>
	{
		let splideElement = el.querySelector<HTMLElement>(".splide");

		if (splideElement)
		{
			var splide = new Splide(splideElement, {
				pagination: true,
				gap: 20,
				mediaQuery: "min",
				fixedWidth: 300,
				arrows: false,
				flickPower: 10,
				breakpoints: {
					768: {
						pagination: false,
						arrows: true,
						fixedWidth: 360,
						slideFocus: "false"
					}
				}
			}).mount();


			var scrollbar = el.querySelector<HTMLElement>(".large-content-slider .custom-scrollbar");
			var thumb = el.querySelector<HTMLElement>(".large-content-slider .scrollbar-thumb");

			if (scrollbar != null && thumb != null)
			{
				new SyncScrollbar(splide, scrollbar, thumb, false);
			}
		}
	});
});




class SyncScrollbar
{
	constructor(splide: Splide, scrollbar: HTMLElement, thumb: HTMLElement, isRTL: boolean)
	{
		function updateThumbWidth()
		{
			var totalSlides = splide.length;
			var visibleSlides = splide.options.perPage;

			if (visibleSlides != undefined && thumb != null)
			{
				var percentage = (visibleSlides / totalSlides) * 100;
				thumb.style.width = `${percentage}%`;
			}
		}

		updateThumbWidth();

		splide.on("move", function ()
		{
			if (splide.options.perPage != undefined && thumb != null && scrollbar != null)
			{
				var progress = splide.index / (splide.length - splide.options.perPage);
				thumb.style.left = progress * (scrollbar.clientWidth - thumb.clientWidth) + "px";
			}
		});

		// Drag scrollbar to control slider
		let isDragging = false;
		let startX: number, startLeft: number, startRight: number;

		if (thumb != null)
		{
			thumb.addEventListener("mousedown", function (e)
			{
				if (thumb != null)
				{
					isDragging = true;
					startX = e.clientX;
					startLeft = thumb.offsetLeft;
					startRight = thumb.offsetLeft - thumb.clientWidth;
					thumb.style.cursor = "grabbing";
					thumb.style.transition = "none";
				}

			});
		}

		document.addEventListener("mousemove", function (e)
		{
			if (!isDragging) return;

			if (scrollbar != null && thumb != null && splide.options.perPage != undefined)
			{
				let deltaX = e.clientX - startX;
				if (isRTL)
				{
					deltaX *= -1;
				}
				let newLeft = startLeft + deltaX;

				newLeft = Math.max(0, Math.min(newLeft, scrollbar.clientWidth - thumb.clientWidth));

				thumb.style.left = (newLeft) + "px";

				// Move SplideJS based on scrollbar position
				let percentage = newLeft / (scrollbar.clientWidth - thumb.clientWidth);
				let newIndex = Math.round(percentage * (splide.length - splide.options.perPage));
				splide.go(newIndex);
			}


		});

		document.addEventListener("mouseup", function ()
		{
			if (thumb != null)
			{
				isDragging = false;
				thumb.style.cursor = "grab";
				thumb.style.transition = "";
			}

		});
	}
}